import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewContextSelectorComponent } from './preview-context-selector.component';
import { BusinessSelectorDialogModule } from '@vendasta/businesses';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ContactSelectorComponent } from './contact-selector-modal/contact-selector.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { InViewportModule } from 'ng-in-viewport';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CrmFieldService } from '@galaxy/crm/static';

@NgModule({
  declarations: [PreviewContextSelectorComponent, ContactSelectorComponent],
  providers: [CrmFieldService],
  imports: [
    CommonModule,
    GalaxyFormFieldModule,
    GalaxyTooltipModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    BusinessSelectorDialogModule,
    MatDialogModule,
    FormsModule,
    InViewportModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
  ],
  exports: [PreviewContextSelectorComponent, ContactSelectorComponent],
})
export class PreviewContextSelectorModule {}
